import React from 'react';

import * as styles from './AppleIcon.css';

export const AppleIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    xmlSpace="preserve"
    viewBox="0 0 17 20"
    className={`${styles.appleLogo}`}
    {...props}
  >
    <path d="M9 1.75C9.36656 1.24328 9.84043 0.823699 10.3878 0.521199C10.9352 0.218699 11.5426 0.0407339 12.1667 0C12.2211 0.56793 12.1606 1.141 11.9888 1.68505C11.817 2.22909 11.5374 2.73298 11.1667 3.16667C10.8281 3.6382 10.375 4.01571 9.85016 4.26357C9.32527 4.51143 8.74588 4.62148 8.16667 4.58333C8.10656 4.07925 8.14942 3.5682 8.29267 3.08118C8.43591 2.59415 8.67655 2.14127 9 1.75ZM4.83333 4.83333C2.5 4.83333 0 6.91667 0 10.9167C0 15 2.91667 20 5.25 20C6.08333 20 7.33333 19.1667 8.58333 19.1667C9.83333 19.1667 10.75 19.9167 11.9167 19.9167C14.5 19.9167 16.3333 14.5833 16.3333 14.5833C15.537 14.2397 14.8595 13.6693 14.3853 12.9431C13.9111 12.217 13.6611 11.3673 13.6667 10.5C13.6672 9.73981 13.8676 8.99313 14.2479 8.33491C14.6282 7.67669 15.175 7.13009 15.8333 6.75C15.4061 6.1094 14.8217 5.58913 14.136 5.23896C13.4502 4.88879 12.6861 4.72043 11.9167 4.75C10.25 4.75 9 5.66667 8.33333 5.66667C7.58333 5.66667 6.33333 4.83333 4.83333 4.83333Z" />
  </svg>
);
